import { bl_del_job_docline_link_RowClass, bl_del_job_docline_link_RowInterface } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobDocLineLinkContainerModel extends BaseContainerModel {
  bl_del_job_docline_link: bl_del_job_docline_link_RowInterface = new bl_del_job_docline_link_RowClass();
}